import axios from 'axios';

function cancelRequest(options, params) {
  if (!params.cancelHandler) {
    return options;
  }
  /* eslint-disable no-param-reassign */
  options = options || {};
  if (params.cancelHandler) {
    const { cancelHandler } = params;
    delete params.cancelHandler;
    const source = axios.CancelToken.source();
    source.token.$cancel = source.cancel;
    options.cancelToken = source.token;
    cancelHandler(source.cancel);
  }
  return options;
}

export default cancelRequest;
